import "./AddOns.css";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setAddOns } from "../../redux/reducer";

const AddOns = () => {
  const planDuration = useSelector((state) => state.planDuration);
  const addOns = useSelector((state) => state.addOns);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    console.log(e.target.id);
    const updatedList = addOns.map((item) =>
      item.id === Number(e.target.id)
        ? { ...item, checked: !item.checked }
        : item
    );

    console.log(updatedList);

    dispatch(setAddOns(updatedList));
  };

  return (
    <div className="addons">
      {addOns.map((addOn) => {
        return (
          <div className="addons__card parentCard">
            <div className="addons__check">
              <input
                className="addons__checkbox"
                type="checkbox"
                id={addOn.id}
                checked={addOn.checked}
                onChange={handleChange}
              />
            </div>

            <div className="addons__content">
              <h4 className="addons__title">{addOn.addOnInfo}</h4>
              <p className="addons__desc">{addOn.desc}</p>
            </div>

            <div className="addons__price">
              {planDuration === "Monthly"
                ? `+$${addOn.price}/mo`
                : `+$${addOn.yearlyPrice}/yr`}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AddOns;
